import React, {useEffect, useState } from "react";
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

function OurExpediation() {

     

   const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
   <>
   
   
        <Header />
   
      <div className="wrapper">
          <div className="bradcumb-area style-aboutt">
				<div className="container">
					<div className="row justify-content-center">
						<div className="col">
						
							{/* <div className="bradcumb text-center">
								<h3>About Nimas</h3>
							</div>
						 */}
						</div>
					</div>
				</div>
			</div>

          </div>
     <div className="about-adventure-area pt-110 pb-200">
				<div className="container">
					
					<div className="row justify-content-center">
						<div className="col-lg-10">
                                <div>
                                       <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')} className="acc-ordian">
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        ><div className="circle"><img src="images/tirangaa.png" alt="" /> </div>
          <Typography component="span" sx={{ width: '33%', flexShrink: 0 }}>
       <b>HAR SHIKHAR TIRANGA Mission</b> 
          </Typography>
        
        </AccordionSummary>
       
        <AccordionDetails>
           
          <Typography>

            <div className="row gllry">
               

                  <div className="col-lg-4">
                            <div className="imgbl dd-flex">
                            <img src="images/tirangaa.png" alt="" />
                             
                            </div>
                        </div>
                           <div className="col-lg-4">
                            <div className="imgbl">
                            <img src="images/tirangaa3.png" alt="" />
                            </div>
                        </div>

                  <div className="col-lg-4">
                     <div className="imgbl imgbl2">
                          <iframe width="560" height="100%" src="https://www.youtube.com/embed/J3kwFNWjN5U?si=9vNL1l8lERV7BKiH&amp;start=3" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    {/* <img src="images/tirangaa3.png" alt="" /> */}
                    </div>
                </div>

                

            </div>

              <div className="row">
                  {/* <div className="col-lg-5">
                     <img src="images/tirangaa2.png" alt="" />
                  </div> */}


                <div className="col-lg-12">
          
            <h3><b>HAR SHIKHAR TIRANGA Mission </b></h3>



    <p> HAR SHIKHAR TIRANGA Mission is a visionary national initiative that reflects the spirit of patriotism, unity and adventure through the unfurling of the Indian Tricolour atop the highest peaks of every state and union territory of India. Conceptualized and executed under the dynamic leadership of Colonel Ranveer Singh Jamwal, SM, VSM**, Director of the National Institute of Mountaineering and Adventure Sports (NIMAS), this mission symbolizes the fusion of courage, national pride and outdoor excellence.</p>


    </div>
    </div>
    <p>The mission brings together elite mountaineers, military personnel, and youth adventurers in an unprecedented effort to blend geographical exploration with patriotic expression. A major highlight was the successful summit of Mt. Gorichen (6488M), the highest peak in Arunachal Pradesh, on 18 September 2024, followed by the first-ever ascent of the virgin peak Mt. Gorichen West (6383M) on 21 September 2024. This historic achievement earned a coveted entry in the World Book of Records under the "Har Shikhar Tiranga" initiative.
</p>

  <p>Under Colonel Jamwal’s exemplary leadership, the mission also stands as a platform for promoting environmental conservation, gender equality, youth empowerment, and national integration. Every peak conquered and every Tricolour hoisted serves as a tribute to the unity in diversity that defines India.
</p>

    <p> HAR SHIKHAR TIRANGA Mission is more than a mountaineering campaign — it is a movement that inspires every Indian to rise, conquer, and celebrate the spirit of the nation.
</p>
  
          </Typography>
        </AccordionDetails>
      </Accordion>

      
      <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}  className="acc-ordian">
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
        >
          <div className="circle"><img src="images/tirangaa2.png" alt="" /> </div>
          <Typography component="span" sx={{ width: '33%', flexShrink: 0 }}>
       <b>Expedition Name</b> 
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
                 <div className="row gllry">
               

                  <div className="col-lg-4">
                            <div className="imgbl dd-flex">
                            <img src="images/tirangaa.png" alt="" />
                             
                            </div>
                        </div>
                           <div className="col-lg-4">
                            <div className="imgbl">
                            <img src="images/tirangaa3.png" alt="" />
                            </div>
                        </div>

                  <div className="col-lg-4">
                     <div className="imgbl">
                          <iframe width="560" height="100%" src="https://www.youtube.com/embed/J3kwFNWjN5U?si=9vNL1l8lERV7BKiH&amp;start=3" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    {/* <img src="images/tirangaa3.png" alt="" /> */}
                    </div>
                </div>

                

            </div>

              <div className="row">
                  {/* <div className="col-lg-5">
                     <img src="images/tirangaa2.png" alt="" />
                  </div> */}


                <div className="col-lg-12">
          
            <h3><b>Expedition Name</b></h3>



    <p> HAR SHIKHAR TIRANGA Mission is a visionary national initiative that reflects the spirit of patriotism, unity and adventure through the unfurling of the Indian Tricolour atop the highest peaks of every state and union territory of India. Conceptualized and executed under the dynamic leadership of Colonel Ranveer Singh Jamwal, SM, VSM**, Director of the National Institute of Mountaineering and Adventure Sports (NIMAS), this mission symbolizes the fusion of courage, national pride and outdoor excellence.</p>


    </div>
    </div>
    <p>The mission brings together elite mountaineers, military personnel, and youth adventurers in an unprecedented effort to blend geographical exploration with patriotic expression. A major highlight was the successful summit of Mt. Gorichen (6488M), the highest peak in Arunachal Pradesh, on 18 September 2024, followed by the first-ever ascent of the virgin peak Mt. Gorichen West (6383M) on 21 September 2024. This historic achievement earned a coveted entry in the World Book of Records under the "Har Shikhar Tiranga" initiative.
</p>

  <p>Under Colonel Jamwal’s exemplary leadership, the mission also stands as a platform for promoting environmental conservation, gender equality, youth empowerment, and national integration. Every peak conquered and every Tricolour hoisted serves as a tribute to the unity in diversity that defines India.
</p>

    <p> HAR SHIKHAR TIRANGA Mission is more than a mountaineering campaign — it is a movement that inspires every Indian to rise, conquer, and celebrate the spirit of the nation.
</p>
          </Typography>
        </AccordionDetails>
      </Accordion>
    
                                </div>
						</div>
					</div>
					
				</div>
			</div>

        <Footer/>
 
   
   </>
  );
}

export default OurExpediation;
